import React from "react";
import { Link } from "react-router-dom";
import "../../assets/css/legal.css";
import minutezillaLogoWhite from "../../assets/images/minutezilla-logo-white.png";

export default function AGB() {
  return (
    <div className="legal-root">

      {/* Top bar */}
      <div className="legal-topbar">
        <Link to="/login" className="legal-topbar-brand">
          <div className="legal-topbar-logo">
            <img src={minutezillaLogoWhite} alt="Minutezilla" className="legal-topbar-logo__img" />
          </div>
        </Link>
        <Link to="/login" className="legal-topbar-back">
          ← Zurück zum Login
        </Link>
      </div>

      <div className="legal-wrapper">

        {/* Header */}
        <div className="legal-header">
          <div className="legal-badge">Nutzungsbedingungen</div>
          <h1 className="legal-title">Allgemeine Geschäftsbedingungen (AGB)</h1>
          <p className="legal-subtitle">
            Für die Nutzung der SaaS-Plattform Minutezilla
          </p>
          <p className="legal-updated">Stand: März 2026</p>
        </div>

        {/* Table of contents */}
        <div className="legal-toc">
          <p>Inhaltsverzeichnis</p>
          <ol>
            <li><a href="#geltungsbereich">Geltungsbereich und Vertragsparteien</a></li>
            <li><a href="#leistungen">Leistungsbeschreibung</a></li>
            <li><a href="#registrierung">Registrierung und Nutzerkonto</a></li>
            <li><a href="#nutzungsrechte">Nutzungsrechte</a></li>
            <li><a href="#pflichten">Pflichten des Nutzers</a></li>
            <li><a href="#verguetung">Vergütung und Zahlung</a></li>
            <li><a href="#verfuegbarkeit">Verfügbarkeit</a></li>
            <li><a href="#datenschutz">Datenschutz und Auftragsverarbeitung</a></li>
            <li><a href="#haftung">Haftung</a></li>
            <li><a href="#kuendigung">Laufzeit und Kündigung</a></li>
            <li><a href="#aenderungen">Änderungen der AGB</a></li>
            <li><a href="#schlussbestimmungen">Schlussbestimmungen</a></li>
          </ol>
        </div>

        <div className="legal-content">

          {/* 1. Geltungsbereich */}
          <div className="legal-section" id="geltungsbereich">
            <h2>§ 1 Geltungsbereich und Vertragsparteien</h2>
            <p>
              (1) Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle Verträge zwischen
              <strong>Sivaprasad Sisupalan</strong>, Speckenkamp 12, 38442 Wolfsburg,
              Deutschland (nachfolgend „Anbieter") und den Nutzern der SaaS-Plattform
              Minutezilla (nachfolgend „Nutzer" oder „Kunde").
            </p>
            <p>
              (2) Minutezilla richtet sich ausschließlich an Unternehmer im Sinne von § 14 BGB,
              d. h. natürliche oder juristische Personen oder rechtsfähige Personengesellschaften,
              die den Dienst im Rahmen ihrer gewerblichen oder selbständigen beruflichen Tätigkeit
              nutzen. Die Nutzung durch Verbraucher im Sinne von § 13 BGB ist ausgeschlossen.
            </p>
            <p>
              (3) Abweichende AGB des Nutzers finden keine Anwendung, es sei denn, der Anbieter
              stimmt ihrer Geltung ausdrücklich schriftlich zu.
            </p>
          </div>

          {/* 2. Leistungen */}
          <div className="legal-section" id="leistungen">
            <h2>§ 2 Leistungsbeschreibung</h2>
            <p>
              (1) Der Anbieter stellt den Nutzern eine cloudbasierte Software-as-a-Service
              (SaaS)-Plattform zur Zeiterfassung und Personalverwaltung zur Verfügung. Der
              Funktionsumfang umfasst insbesondere:
            </p>
            <ul>
              <li>Zeiterfassung (Start/Stopp-Timer, manuelle Einträge)</li>
              <li>Projekt- und Kundenverwaltung</li>
              <li>Berichte und Analysen</li>
              <li>Anwesenheitserfassung (Check-in/Check-out, Pausen)</li>
              <li>Urlaubsverwaltung und Genehmigungsworkflows</li>
              <li>Überstundenberechnung</li>
              <li>Teamverwaltung mit Rollenkonzept (Admin, Manager, Member)</li>
            </ul>
            <p>
              (2) Der Anbieter ist berechtigt, den Leistungsumfang zu erweitern, einzuschränken
              oder zu ändern, sofern dies dem Nutzer zumutbar ist und die wesentlichen
              Vertragspflichten nicht beeinträchtigt werden. Der Nutzer wird über wesentliche
              Änderungen rechtzeitig informiert.
            </p>
            <p>
              (3) Die jeweils aktuelle Leistungsbeschreibung ist unter
              <a href="https://app.minutezilla.com"> app.minutezilla.com</a> abrufbar.
            </p>
          </div>

          {/* 3. Registrierung */}
          <div className="legal-section" id="registrierung">
            <h2>§ 3 Registrierung und Nutzerkonto</h2>
            <p>
              (1) Die Nutzung von Minutezilla setzt eine Registrierung und die Erstellung eines
              Nutzerkontos voraus. Die Registrierung ist kostenlos.
            </p>
            <p>
              (2) Bei der Registrierung sind wahrheitsgemäße und vollständige Angaben zu machen.
              Der Nutzer ist verpflichtet, seine Zugangsdaten sicher aufzubewahren und unbefugten
              Dritten nicht zugänglich zu machen.
            </p>
            <p>
              (3) Pro E-Mail-Adresse darf nur ein Konto erstellt werden. Mehrfachkonten sind
              nicht gestattet.
            </p>
            <p>
              (4) Der Anbieter behält sich vor, Konten zu sperren oder zu löschen, wenn
              begründeter Verdacht auf Missbrauch besteht oder die AGB verletzt werden.
            </p>
          </div>

          {/* 4. Nutzungsrechte */}
          <div className="legal-section" id="nutzungsrechte">
            <h2>§ 4 Nutzungsrechte</h2>
            <p>
              (1) Der Anbieter räumt dem Nutzer für die Laufzeit des Vertrags ein einfaches,
              nicht übertragbares und nicht unterlizenzierbares Recht ein, die Plattform
              bestimmungsgemäß zu nutzen.
            </p>
            <p>
              (2) Die Plattform darf nicht kopiert, verändert, rückentwickelt (Reverse
              Engineering), dekompiliert oder anderweitig manipuliert werden.
            </p>
            <p>
              (3) Alle Rechte an der Plattform, der Software und den Inhalten verbleiben beim
              Anbieter. Die Nutzungsrechte des Kunden erlöschen mit Vertragsende automatisch.
            </p>
          </div>

          {/* 5. Pflichten des Nutzers */}
          <div className="legal-section" id="pflichten">
            <h2>§ 5 Pflichten des Nutzers</h2>
            <p>
              (1) Der Nutzer verpflichtet sich:
            </p>
            <ul>
              <li>die Plattform nur bestimmungsgemäß und in Übereinstimmung mit geltendem Recht zu nutzen;</li>
              <li>keine rechtswidrigen, beleidigenden oder irreführenden Inhalte einzugeben;</li>
              <li>keine automatisierten Zugriffe (Bots, Scraper) ohne ausdrückliche schriftliche Genehmigung des Anbieters zu verwenden;</li>
              <li>den Anbieter unverzüglich über bekannt gewordene Sicherheitslücken oder Missbrauch zu informieren;</li>
              <li>bei der Nutzung des HR-Moduls die anwendbaren arbeitsrechtlichen Vorschriften, insbesondere das Arbeitszeitgesetz (ArbZG), einzuhalten.</li>
            </ul>
            <p>
              (2) Der Nutzer trägt die alleinige Verantwortung für die von ihm oder seinen
              Mitarbeitern eingegebenen Daten.
            </p>
            <p>
              (3) Bei Datenschutzverletzungen, die den Anbieter betreffen, ist der Nutzer
              verpflichtet, den Anbieter unverzüglich zu informieren.
            </p>
          </div>

          {/* 6. Vergütung */}
          <div className="legal-section" id="verguetung">
            <h2>§ 6 Vergütung und Zahlung</h2>
            <p>
              (1) Die Basisversion von Minutezilla ist kostenlos nutzbar. Kostenpflichtige
              Premium-Funktionen werden gesondert ausgewiesen und erfordern ein aktives Abonnement.
            </p>
            <p>
              (2) Die Preise für kostenpflichtige Tarife sind der aktuellen Preisübersicht auf
              der Website zu entnehmen. Alle Preise verstehen sich zuzüglich der gesetzlichen
              Umsatzsteuer.
            </p>
            <p>
              (3) Zahlungen sind im Voraus fällig. Bei ausbleibender Zahlung ist der Anbieter
              berechtigt, den Zugang zu Premium-Funktionen einzuschränken oder zu sperren.
            </p>
          </div>

          {/* 7. Verfügbarkeit */}
          <div className="legal-section" id="verfuegbarkeit">
            <h2>§ 7 Verfügbarkeit</h2>
            <p>
              (1) Der Anbieter strebt eine Verfügbarkeit der Plattform von 99 % im Jahresmittel
              an, ausgenommen geplante Wartungszeiten.
            </p>
            <p>
              (2) Geplante Wartungsarbeiten werden dem Nutzer nach Möglichkeit mindestens 24
              Stunden im Voraus angekündigt.
            </p>
            <p>
              (3) Ein Anspruch auf ununterbrochene Verfügbarkeit besteht nicht. Störungen durch
              höhere Gewalt (z. B. Netzausfall, DDoS-Angriffe) sind ausgenommen.
            </p>
          </div>

          {/* 8. Datenschutz und Auftragsverarbeitung */}
          <div className="legal-section" id="datenschutz">
            <h2>§ 8 Datenschutz und Auftragsverarbeitung</h2>
            <p>
              (1) Der Umgang mit personenbezogenen Daten richtet sich nach der
              <Link to="/datenschutz"> Datenschutzerklärung</Link> des Anbieters sowie der
              Datenschutz-Grundverordnung (DSGVO).
            </p>
            <p>
              (2) Soweit der Nutzer über Minutezilla personenbezogene Daten seiner Mitarbeiter
              verarbeitet (z. B. Zeiterfassung, Anwesenheit), handelt der Anbieter als
              Auftragsverarbeiter gemäß Art. 28 DSGVO. In diesem Fall ist der Abschluss eines
              Auftragsverarbeitungsvertrags (AVV) erforderlich. Der Nutzer kann den AVV
              unter <a href="mailto:kontakt@minutezilla.com">kontakt@minutezilla.com</a> anfordern.
            </p>
            <p>
              (3) Der Nutzer ist als Verantwortlicher gemäß Art. 4 Nr. 7 DSGVO für die
              rechtmäßige Verarbeitung der Mitarbeiterdaten verantwortlich, insbesondere für
              die korrekte Rechtsgrundlage, Informationspflichten gegenüber Mitarbeitern und
              Betriebsvereinbarungen gemäß § 87 Abs. 1 Nr. 6 BetrVG.
            </p>
          </div>

          {/* 9. Haftung */}
          <div className="legal-section" id="haftung">
            <h2>§ 9 Haftung</h2>
            <p>
              (1) Der Anbieter haftet unbeschränkt für Schäden aus der Verletzung des Lebens,
              des Körpers oder der Gesundheit sowie für Schäden, die auf Vorsatz oder grober
              Fahrlässigkeit beruhen.
            </p>
            <p>
              (2) Bei leichter Fahrlässigkeit haftet der Anbieter nur bei Verletzung einer
              wesentlichen Vertragspflicht (Kardinalpflicht) und nur in Höhe des
              vorhersehbaren, typischerweise eintretenden Schadens.
            </p>
            <p>
              (3) Der Anbieter übernimmt keine Haftung für den Verlust von Daten, sofern der
              Nutzer keine regelmäßigen Datensicherungen vorgenommen hat.
            </p>
            <p>
              (4) Die Haftung für mittelbare Schäden, Folgeschäden und entgangenen Gewinn ist
              ausgeschlossen, soweit gesetzlich zulässig.
            </p>
          </div>

          {/* 10. Kündigung */}
          <div className="legal-section" id="kuendigung">
            <h2>§ 10 Laufzeit und Kündigung</h2>
            <p>
              (1) Der Vertrag wird auf unbestimmte Zeit geschlossen und kann von beiden Seiten
              jederzeit ohne Angabe von Gründen ordentlich gekündigt werden.
            </p>
            <p>
              (2) Kostenpflichtige Abonnements können mit einer Frist von 30 Tagen zum Ende des
              jeweiligen Abrechnungszeitraums gekündigt werden.
            </p>
            <p>
              (3) Das Recht zur außerordentlichen Kündigung aus wichtigem Grund bleibt unberührt.
              Ein wichtiger Grund liegt für den Anbieter insbesondere vor, wenn der Nutzer
              wesentliche Pflichten aus diesen AGB wiederholt verletzt.
            </p>
            <p>
              (4) Nach Vertragsende wird das Konto des Nutzers gesperrt. Gespeicherte Daten
              werden nach einer Übergangsfrist von 30 Tagen gelöscht, sofern keine gesetzlichen
              Aufbewahrungspflichten entgegenstehen.
            </p>
          </div>

          {/* 11. Änderungen */}
          <div className="legal-section" id="aenderungen">
            <h2>§ 11 Änderungen der AGB</h2>
            <p>
              (1) Der Anbieter behält sich vor, diese AGB mit einer Ankündigungsfrist von
              mindestens 30 Tagen zu ändern. Die Änderungen werden dem Nutzer per E-Mail
              mitgeteilt.
            </p>
            <p>
              (2) Widerspricht der Nutzer den geänderten AGB nicht innerhalb von 30 Tagen nach
              Zugang der Mitteilung, gelten die geänderten AGB als akzeptiert. Auf dieses
              Widerspruchsrecht und dessen Folgen wird in der Ankündigung ausdrücklich
              hingewiesen.
            </p>
          </div>

          {/* 12. Schlussbestimmungen */}
          <div className="legal-section" id="schlussbestimmungen">
            <h2>§ 12 Schlussbestimmungen</h2>
            <p>
              (1) Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des
              UN-Kaufrechts (CISG).
            </p>
            <p>
              (2) Ausschließlicher Gerichtsstand für alle Streitigkeiten aus oder im Zusammenhang
              mit diesem Vertrag ist der Sitz des Anbieters, soweit der Nutzer Kaufmann,
              juristische Person des öffentlichen Rechts oder öffentlich-rechtliches
              Sondervermögen ist.
            </p>
            <p>
              (3) Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder werden, berührt
              dies die Wirksamkeit der übrigen Bestimmungen nicht.
            </p>
            <p>
              (4) Mündliche Nebenabreden bestehen nicht. Änderungen und Ergänzungen bedürfen
              der Textform.
            </p>
          </div>

        </div>

        {/* Footer strip */}
        <div className="legal-footer-strip">
          <p>&copy; {new Date().getFullYear()} Minutezilla. Alle Rechte vorbehalten.</p>
          <div>
            <Link to="/impressum">Impressum</Link>
            <Link to="/datenschutz">Datenschutz</Link>
            <Link to="/agb">AGB</Link>
          </div>
        </div>

      </div>
    </div>
  );
}
